import { render, staticRenderFns } from "./HKLTextarea.vue?vue&type=template&id=a8834fc4&scoped=true&"
import script from "./HKLTextarea.vue?vue&type=script&lang=js&"
export * from "./HKLTextarea.vue?vue&type=script&lang=js&"
import style0 from "./HKLTextarea.vue?vue&type=style&index=0&id=a8834fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8834fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8834fc4')) {
      api.createRecord('a8834fc4', component.options)
    } else {
      api.reload('a8834fc4', component.options)
    }
    module.hot.accept("./HKLTextarea.vue?vue&type=template&id=a8834fc4&scoped=true&", function () {
      api.rerender('a8834fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Input/HKLTextarea.vue"
export default component.exports